import { OpenURLFn } from "./types";

const openURL: OpenURLFn = (url, { target } = {}) => {
	window.open(url, target);
};
export default openURL;
